import React from 'react'
import TablePage from "../../common/TablePage";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../localization";
import { withSnackbar } from "notistack";
import { deleteUserRole, getUserRoles } from "../../services/userRoles/UserRoleService";
import AddUserRole from "./AddUserRole"
import EditUserRole from './EditUserRole';

class UserRoleList extends TablePage {

    tableDescription = [
        { key: 'userName', label: strings.userRole.name, sort: 'userName' },
        { key: 'userSurname', label: strings.userRole.surname, sort: 'userSurname' },
        { key: 'role', label: strings.userRole.role, sort: 'role' },
        { key: 'dateCreated', label: strings.stateList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
      ];

    constructor(props) {
        super(props);
    
        this.state.showDeleted = false;
        // this.state.sortBy = "name,ASC";
        
    
      }
      usePermissions(){
        let data = {
          userId: this.props.auth.user.id,
          category: "Рола корисника"
        }
        this.getPermissionsS(data);
        
      }
    
      componentDidMount() {
        this.usePermissions()
        this.setState({
          companyId: this.props.auth.user.company.id
        }, () => { this.fetchData(); })
      }

      componentWillReceiveProps(nextProps){
        strings.setLanguage(nextProps.auth.user.language);
        this.tableDescription = [
          { key: 'userName', label: strings.userRole.name, sort: 'userName' },
          { key: 'userSurname', label: strings.userRole.surname, sort: 'userSurname' },
          { key: 'roleName', label: strings.userRole.role, sort: 'roleName' },
          { key: 'dateCreated', label: strings.stateList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
        ];
      }
      fetchData() {
        let data = {
            searchParam: this.state.searchData.search,
            page: this.state.searchData.page - 1,
            size: this.state.searchData.perPage,
            companyId: this.state.companyId,
            // sort: this.state.sortBy,
            userId: this.props.auth.user.id
        };

        getUserRoles(data).then(response => {
            if (!response.ok) {
              return;
            }
            this.setState({
              tableData: response.data.entities,
              total: response.data.total,
            });
          });
    }

    delete(item) {

      this.setState({
        lockTable: true
      });
  
  
      deleteUserRole(item.id, this.props.auth.user.id).then(response => {
  
        if (response && !response.ok) {
          this.onFinish(null);
          return;
        }
  
        this.props.enqueueSnackbar(strings.userRole.userRoleDeleted, { variant: 'success' });
  
        this.onFinish(item);
        this.cancelDelete();
  
        this.setState({
          lockTable: false
        });
      });
    }

    renderEditContent(){
      return <EditUserRole 
        id={this.state.selectedItem.id}
        uemail={this.props.auth.user.email}
        cid={this.state.companyId}
        onCancel={this.onCancel}
        onFinish={this.onFinish}
        isDisabled={false}
        flag={"edit"}
      />
    }
    renderAddContent() {
        return <AddUserRole cid={this.state.companyId} uemail={this.props.auth.user.email} onCancel={this.onCancel} onFinish={this.onFinish} flag={"add"} />
      }


      getPageHeader() {
        return <h1>{strings.userRole.pageTitle}</h1>;
      }

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      changeFullScreen: Actions.changeFullScreen
    }, dispatch);
  }
  
  function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
    return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
  }
  
  export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(UserRoleList)));